export { default as PencilAltSolidIcon } from './PencilAltSolidIcon';
